export const FORM_TYPES = {
    ADD_CHECK_BOX: "AddCheckBox",
    ADD_DROP_DOWN: "AddDropDown",
    ADD_DATE_PICKER: "AddDatePicker",
    ADDED_DROP_DOWNN:"AddedDropDown",
    ADD_RADIO_BUTTON:"AddRadioButton"
}